module.exports = __webpack_public_path__ + "img/Jump Casting30.62558a6f.jpg";